import { useDispatch, useSelector } from "react-redux";
import {
  addBoard,
  updateBoard,
  deleteBoard,
} from "../redux/slices/boardsSlice";

export const useBoards = (projectId) => {
  const dispatch = useDispatch();
  const { boards } = useSelector((state) => state.boards);

  const projectBoards = boards
    .filter((b) => b.projectId === projectId)
    .sort((a, b) => a.order - b.order);

  const createBoard = (title) => {
    dispatch(addBoard({ projectId, title }));
  };

  const editBoard = (id, updates) => {
    dispatch(updateBoard({ id, updates }));
  };

  const removeBoard = (id) => {
    dispatch(deleteBoard(id));
  };

  return { boards: projectBoards, createBoard, editBoard, removeBoard };
};
